import { ErrorSource, RequestType, initFetchObservable, computeStackTrace, toStackTraceString, noop, isServerError, isIntakeUrl, safeTruncate, } from '@datadog/browser-core';
import { StatusType } from '../logger/isAuthorized';
export function startNetworkErrorCollection(configuration, lifeCycle, bufferedDataObservable) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: noop };
    }
    // Register responseBodyAction getter (no subscription needed)
    initFetchObservable({
        responseBodyAction: (context) => (isNetworkError(context) ? 1 /* ResponseBodyAction.COLLECT */ : 0 /* ResponseBodyAction.IGNORE */),
    });
    const subscription = bufferedDataObservable.subscribe(({ data, type }) => {
        if (type === 1 /* BufferedDataType.FETCH */ && data.state === 'resolve') {
            handleResponse(RequestType.FETCH, data);
        }
        else if (type === 2 /* BufferedDataType.XHR */ && data.state === 'complete') {
            handleResponse(RequestType.XHR, data);
        }
    });
    function isNetworkError(request) {
        return !isIntakeUrl(request.url) && !request.isAborted && (isRejected(request) || isServerError(request.status));
    }
    function handleResponse(type, request) {
        if (!isNetworkError(request)) {
            return;
        }
        const stack = 'error' in request && request.error
            ? toStackTraceString(computeStackTrace(request.error))
            : request.responseBody || 'Failed to load';
        const domainContext = {
            handlingStack: request.handlingStack,
        };
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: `${format(type)} error ${request.method} ${request.url}`,
                date: request.startClocks.timeStamp,
                error: {
                    stack: safeTruncate(stack, configuration.requestErrorResponseLengthLimit, '...'),
                    // We don't know if the error was handled or not, so we set it to undefined
                    handling: undefined,
                },
                http: {
                    method: request.method, // Cast resource method because of case mismatch cf issue RUMF-1152
                    status_code: request.status,
                    url: request.url,
                },
                status: StatusType.error,
                origin: ErrorSource.NETWORK,
            },
            domainContext,
        });
    }
    return { stop: () => subscription.unsubscribe() };
}
function isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
function format(type) {
    if (RequestType.XHR === type) {
        return 'XHR';
    }
    return 'Fetch';
}
//# sourceMappingURL=networkErrorCollection.js.map